import { defineCatalogue } from '../../i18n';

export const stateCatalogue = defineCatalogue(
  {
    'failure.unauthenticated': 'Sua sessão expirou. Entre novamente.',
    'failure.forbidden': 'Esta conta não tem o direito necessário para isto.',
    'failure.not-found': 'Isto não existe mais, ou nunca existiu.',
    'failure.conflict': 'Não foi possível concluir: {message}',
    'failure.invalid': '{message}',
    'failure.server': 'O servidor não respondeu como esperado. Tente novamente.',
    'failure.offline': 'Sem conexão. Verifique a rede e tente novamente.',
    'failure.malformed': 'Não conseguimos ler esta resposta.',
    retry: 'Tentar novamente',
    loading: 'Carregando',
  },
  {
    'failure.unauthenticated': 'Your session has expired. Sign in again.',
    'failure.forbidden': 'This account does not hold the grant this needs.',
    'failure.not-found': 'This does not exist any more, or never did.',
    'failure.conflict': 'Could not complete: {message}',
    'failure.invalid': '{message}',
    'failure.server': 'The server did not answer as expected. Try again.',
    'failure.offline': 'No connection. Check the network and try again.',
    'failure.malformed': 'We could not read this answer.',
    retry: 'Try again',
    loading: 'Loading',
  },
);

export const st = stateCatalogue.t;
